var path = '/PrehistoricArtifactAssemblage/'

function get (http, id) {
    return http.get(path + `Get?id=${id}&getComponents=true`)
}
function put (http, assemblageDto) {
    return http.put(path + '?saveComponents=true', assemblageDto)
}
function search (http, searchDto) {
    return http.post(path + 'Search?getComponents=true', searchDto)
}

function getArtifactTypeList () {
    return [
        { artifactTypeId: 2, description: 'Agate Basin' },
        { artifactTypeId: 13, description: 'Avonlea' },
        { artifactTypeId: 12, description: 'Besant' },
        { artifactTypeId: 6, description: 'Bitterroot' },
        {artifactTypeId: 1, description: 'Clovis'},
        { artifactTypeId: 9, description: 'Duncan' },
        {artifactTypeId: 3, description: 'Eden'},
        { artifactTypeId: 10, description: 'Hanna' },
        {artifactTypeId: 4, description: 'Hell Gap'},
        { artifactTypeId: 8, description: 'McKean' },
        { artifactTypeId: 7, description: 'Oxbow' },
        { artifactTypeId: 11, description: 'Pelican Lake' },
        { artifactTypeId: 14, description: 'Plains Side Notched' },
        { artifactTypeId: 16, description: 'Prairie Side Notched' },
        {artifactTypeId: 5, description: 'Scotts Bluff'},
        {artifactTypeId: 15, description: 'Tri-notched'},
        {artifactTypeId: 17, description: 'Triangular'},
        {artifactTypeId: 18, description: 'Unknown'}
    ]
}

function getTechCultureList () {
    return [
        {techCultureId: 1, description: 'Clovis'},
        {techCultureId: 2, description: 'Goshen'},
        {techCultureId: 3, description: 'Folsom'},
        {techCultureId: 4, description: 'Midland'},
        {techCultureId: 5, description: 'Agate Basin'},
        {techCultureId: 6, description: 'Hell gap'},
        {techCultureId: 7, description: 'Alberta'},
        {techCultureId: 8, description: 'Cody'},
        {techCultureId: 9, description: 'Frederick'},
        {techCultureId: 10, description: 'Lusk'},
        {techCultureId: 11, description: 'Pryor Stemmed'},
        {techCultureId: 12, description: 'Bitterroot'},
        {techCultureId: 13, description: 'Oxbow'},
        {techCultureId: 14, description: 'McKean'},
        {techCultureId: 15, description: 'Pelican Lake'},
        {techCultureId: 16, description: 'Besant'},
        {techCultureId: 17, description: 'Avonlea'},
        {techCultureId: 18, description: 'Woodland'},
        {techCultureId: 19, description: 'Unknown'}
    ]
}

export default {
    get: get,
    put: put,
    search: search,
    getArtifactTypeList: getArtifactTypeList,
    getTechCultureList: getTechCultureList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/prehistoricArtifactService.js